export enum PendingMessageStatus {
  Warning = 'global_warning_error',
  Info = 'global_info_error',
  Pending = 'global_pending_error',
  Success = 'global_success_error',
  Failure = 'global_failure_error',
}
